import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../Navbar/navbar.css';
import SocialSubscribe from './SocialSubscribe';
import NavbarLinks from './navlinks';
import NavbarBrand from './navbrand';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="navbar-container">
      <SocialSubscribe />
      <nav className="navbar navbar-expand-lg fixed-top ">
        <div className="container-fluid">
          <NavbarBrand />
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarNav"
            aria-expanded={isOpen ? 'true' : 'false'}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* Pass the isOpen state to NavbarLinks */}
          <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <NavbarLinks isOpen={isOpen} toggleNavbar={toggleNavbar} />
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
